import React from 'react';
import classNames from 'classnames';

export function Block({size = 'md', type = null}) {
    return (
        <div
            className={classNames('bg--shimmer', 'loading--block', {
                [`loading--block__${size}`]: !!size,
            })}
        >
            {type}
        </div>
    );
}

export default Block;
